/**
 * Created by Bart Decorte
 * Date: 09/11/2018
 * Time: 12:18
 */
import UsersManipulate from './UsersManipulate';

class UsersCreate extends UsersManipulate {
  constructor() {
    super();
    this.bindKeys(this.keyBindings());
  }
}

export default UsersCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Users/UsersCreate.js